var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDependent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.17 8.659V4.672h-4.021 8.042"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.17,
    cy: 23.083,
    r: 13.644
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32.604,
    cy: 9.397,
    r: 1.433
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.665 24.655l-5.649-4.152 6.447 2.492c.448.25.688.868.451 1.285-.263.463-.909.561-1.249.375z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.206,
    cy: 23.083,
    r: 13.644
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDependent);
export default __webpack_public_path__ + "static/media/timeDependent.3f4686d4548b39cc147d47123e14ec26.svg";
export { ForwardRef as ReactComponent };